import Shelf from './Shelf'
import type { IShelfProps } from './Shelf.types'

export default Shelf

export { IShelfProps }
